export const FIELD_VALUE_STATES = Object.freeze({
  VALUE: 'value',
  EMPTY: 'empty',
  UNKNOWN: 'unknown',
  LOADING: 'loading',
});

export const UNKNOWN_REASONS = Object.freeze({
  NO_PREDECESSOR: 'noPredecessor',
  PREDECESSOR_PRUNED: 'predecessorPruned',
  PREDECESSOR_UNAVAILABLE: 'predecessorUnavailable',
  KEY_ABSENT_FROM_PREDECESSOR: 'keyAbsentFromPredecessor',
  FOREIGN_LOOKUP_MISSED: 'foreignLookupMissed',
});
